<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section menu" id="menu">
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">MENU</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <h4 class="description-title">コースメニュー</h4>
          <Wrapper>
            <table class="cut-menu">
              <thead>
                <tr>
                  <td scope="col">メニュー名</td>
                  <th scope="col">内容</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text" data-label="メニュー名">シャンプーのみ</th>
                  <td class="price text-align-left" data-label="">シャンプー・ブロー <br>※シャンプーのみは前回トリミングから<span class="strong" :class="{strongFont: isIntersecting}">２週間以内</span>のワンコに限ります。</td>
                </tr>
                <tr>
                  <th class="text" data-label="メニュー名">シャンプーコース</th>
                  <td class="price text-align-left" data-label="">シャンプー、ブロー、爪切り、足裏足回りカット、肛門腺チェック、耳の中チェック(入口のそうじ込)、デンタルチェック、体重測定</td>
                </tr>
                <tr>
                  <th class="text" data-label="メニュー名">カットコース</th>
                  <td class="price text-align-left" data-label="">シャンプーコース・全身カット</td>
                </tr>
              </tbody>
            </table>
            <p><br></p>
          </Wrapper>

          <h4 class="description-title">犬種別料金</h4>
          <Wrapper>
            <table class="cut-menu">
              <thead>
                <tr>
                  <td scope="col">犬種</td>
                  <th scope="col">シャンプーのみ</th>
                  <th scope="col">シャンプーコース</th>
                  <th scope="col">カットコース</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text" data-label="犬種">チワワ<br>ミニチュアダックス<br>（スムース）</th>
                  <td class="price" data-label="シャンプーのみ">-</td>
                  <td class="price" data-label="シャンプーコース">￥3,500</td>
                  <td class="price" data-label="カットコース">-</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">チワワ<br>ミニチュアダックス<br>（ロング）</th>
                  <td class="price" data-label="シャンプーのみ">￥3,000</td>
                  <td class="price" data-label="シャンプーコース">￥5,000</td>
                  <td class="price" data-label="カットコース">￥6,000</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">ヨークシャテリア</th>
                  <td class="price" data-label="シャンプーのみ">￥3,500</td>
                  <td class="price" data-label="シャンプーコース">￥5,000</td>
                  <td class="price" data-label="カットコース">￥6,500</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">マルチーズ</th>
                  <td class="price" data-label="シャンプーのみ">￥3,500</td>
                  <td class="price" data-label="シャンプーコース">￥5,500</td>
                  <td class="price" data-label="カットコース">￥7,000</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">シーズー</th>
                  <td class="price" data-label="シャンプーのみ">￥4,000</td>
                  <td class="price" data-label="シャンプーコース">￥5,500</td>
                  <td class="price" data-label="カットコース">￥7,000</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">ポメラニアン</th>
                  <td class="price" data-label="シャンプーのみ">￥4,500</td>
                  <td class="price" data-label="シャンプーコース">￥6,000</td>
                  <td class="price" data-label="カットコース">￥7,500</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">トイプードル<br>5kg以下</th>
                  <td class="price" data-label="シャンプーのみ">￥4,500</td>
                  <td class="price" data-label="シャンプーコース">￥6,000</td>
                  <td class="price" data-label="カットコース">￥8,000</td>
                </tr>
                <tr>
                  <th class="text" data-label="犬種">トイプードル<br>5kg以上</th>
                  <td class="price" data-label="シャンプーのみ">￥5,000</td>
                  <td class="price" data-label="シャンプーコース">￥7,000</td>
                  <td class="price" data-label="カットコース">￥9,000</td>
                </tr>
              </tbody>
            </table>
          </Wrapper>
          <p>※サイズや毛量によって追加料金を頂戴する場合がございます。</p>
          <p>※初めてのお客様は初回カウンセリング代￥1,000（最終のご来店3ヵ月以上経過も含まれます）。</p>
          <p>※記載の無い犬種はお問い合わせ下さい。</p>
          <p><br></p>

          <h4 class="description-title">プラスオプションサービス（コースに別途追加）</h4>
          <Wrapper>
            <table class="cut-menu">
              <thead>
                <tr>
                  <td scope="col">項目</td>
                  <th scope="col">料金</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text" data-label="項目">部分カット（１か所〜）</th>
                  <td class="price" data-label="料金">￥500～</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">ヒゲカット</th>
                  <td class="price" data-label="料金">￥500</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">毛玉処理</th>
                  <td class="price" data-label="料金">￥500〜</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">抜け毛処理 15分</th>
                  <td class="price" data-label="料金">￥1,000</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">保湿ミルク<br>（保湿ローションに追加。肉球ケア込み）</th>
                  <td class="price" data-label="料金">￥800</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">クレンジングオイル<br>（広範囲・部分使用以外）</th>
                  <td class="price" data-label="料金">￥1,000〜</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">デザインカット<br>（スタンダード以外）<br>アフロ・プチアフロ・アシメ・高耳・モヒカン・トップノット・おパンツ・ハートなど</th>
                  <td class="price" data-label="料金">￥500〜1,000</td>
                </tr>
              </tbody>
            </table>
            <p><br></p>
          </Wrapper>

          <h4 id="uchinoko" class="description-title">うちの子オプション</h4>
          <Wrapper>
            <p>その時その子ができることを…</p>
            <p>時間をかけてゆっくりが良いのか、日にちを分けてが良いのか、今日できなくても明日できるように。</p>
            <p><span class="strong" :class="{strongFont: isIntersecting}">頑張らせずに選択</span>できるようにとの思いで出来たオプションとなります。</p>
            <p>ケア料金として</p>
            <p>いつものコースに追加で15分1000円〜</p>
            <p>詳細は<a class="add-underline" style="color: #5ac2d9" href="https://www.instagram.com/p/CLnjd4RjLHs/?utm_medium=share_sheet">こちら</a>（Instagramへ飛びます）</p>
            <p><br></p>
          </Wrapper>
          
          <h4 class="description-title">サロンを継続的にご利用のお客様限定（要相談）</h4>
          <Wrapper>
            <table class="cut-menu">
              <thead>
                <tr>
                  <td scope="col">項目</td>
                  <th scope="col">料金</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text" data-label="項目">◎もしもの時の出張ケア<br>病気や加齢によりサロンまで来て頂くことがご負担の場合<br>（動物病院での診察必須）</th>
                  <td class="price" data-label="料金">出張代￥2,000+α</td>
                </tr>
                <tr>
                  <th class="text" data-label="項目">◎エンゼルケア<br>ありがとうを伝えるお見送りのお手伝い</th>
                  <td class="price" data-label="料金">出張代￥2,000+α</td>
                </tr>
              </tbody>
            </table>
            <p><br></p>
            <p>※税込価格での表記でございます。</p>
          </Wrapper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Wrapper from './Wrapper'
export default {
  name: 'menu',
  components: {
    Wrapper,
  },
  data(){
    return {
      isIntersecting: false,
    }
  },
  methods: {
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<style lang="scss">
  .menu {
    padding: 20px auto;
  }
  
  table {
    border-collapse: collapse;
    padding: 0;
    max-width: 100%;
    table-layout: fixed;
    color: $dark-font-color;
    tr {
      padding: .35em;
      border-bottom: 1px dotted $dark-font-color;
      &:last-child{
       border-bottom: 1px solid $dark-font-color;
      }
    }
    th,td {
      padding: 1em 10px 1em 1em;
      font-size: 1.5rem;
    }
    thead td {
      font-weight: bold;
    }
    tbody th {
      font-weight: bold;
    }
    .text{
      text-align: left;
      font-size: 1.5rem;
    }
  }
</style>
